// extracted by mini-css-extract-plugin
module.exports = {"terms":"_02712f2b3b--terms--758Uk","term-item":"_02712f2b3b--term-item--zQeuz","term-item--done":"_02712f2b3b--term-item--done--r4wGY"};